'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = require('@material-ui/core/styles');

var _Tooltip = require('@material-ui/core/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _action_mol = require('../actions/action_mol');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles() {
  return {
    root: {
      flexGrow: 1
    },
    baseDD: {
      border: '2px dashed #000',
      borderRadius: 5,
      height: 30,
      lineHeight: '30px',
      margin: '0 0 10px 0',
      textAlign: 'center',
      verticalAlign: 'middle',
      width: '90%'
    },
    tpCard: {},
    tpLabel: {
      fontSize: 16
    }
  };
};

var tpHint = function tpHint(classes) {
  return _react2.default.createElement(
    'span',
    { className: (0, _classnames2.default)(classes.tpCard) },
    _react2.default.createElement(
      'p',
      { className: (0, _classnames2.default)(classes.tpLabel, 'txt-sv-tp') },
      '- Accept *.mol'
    ),
    _react2.default.createElement(
      'p',
      { className: (0, _classnames2.default)(classes.tpLabel, 'txt-sv-tp') },
      '- Max 30Mb'
    )
  );
};

var msgDefault = 'Add Molfile';

var showByMolfile = function showByMolfile(molSt) {
  var src = molSt.src,
      mass = molSt.mass;

  if (src) {
    var txtMass = parseFloat(mass).toFixed(2);
    return src.name + ' (' + txtMass + 'g/mol)';
  }

  return msgDefault;
};

var content = function content(classes, desc) {
  return _react2.default.createElement(
    _Tooltip2.default,
    {
      title: tpHint(classes),
      placement: 'bottom'
    },
    _react2.default.createElement(
      'span',
      null,
      desc
    )
  );
};

var InputMol = function InputMol(_ref) {
  var classes = _ref.classes,
      molSt = _ref.molSt,
      addMolInitAct = _ref.addMolInitAct;

  var onDrop = function onDrop(mols) {
    return addMolInitAct({ mol: mols[0] });
  };

  var desc = showByMolfile(molSt, classes);

  return _react2.default.createElement(
    _reactDropzone2.default,
    {
      className: 'dropbox',
      onDrop: onDrop
    },
    function (_ref2) {
      var getRootProps = _ref2.getRootProps,
          getInputProps = _ref2.getInputProps;
      return _react2.default.createElement(
        'div',
        _extends({}, getRootProps(), {
          className: (0, _classnames2.default)(classes.baseDD)
        }),
        _react2.default.createElement('input', getInputProps()),
        content(classes, desc)
      );
    }
  );
};

var mapStateToProps = function mapStateToProps(state, props) {
  return (// eslint-disable-line
    {
      molSt: state.mol
    }
  );
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    addMolInitAct: _action_mol.addMolInit
  }, dispatch);
};

InputMol.propTypes = {
  classes: _propTypes2.default.object.isRequired,
  molSt: _propTypes2.default.object.isRequired,
  addMolInitAct: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _styles.withStyles)(styles)(InputMol));